document.addEventListener('change', e => {
  if (!e.target.matches('[data-product-option]')) return;
  const form = e.target.closest('form');
  const variants = JSON.parse(form.querySelector('[data-product-variants]').textContent);
  const choices = [...form.querySelectorAll('[data-product-option]')].map(select => select.value);
  const variant = variants.find(item => choices.every((choice, index) => item.options[index] === choice));
  const button = form.querySelector('button[type="submit"]');
  const price = document.querySelector('[data-product-price]');
  const currency = form.querySelector('[data-currency]').dataset.currency || 'USD';
  const formatted = variant ? new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency}).format(variant.price / 100) : '';
  form.querySelector('[data-variant-id]').value = variant ? variant.id : '';
  button.disabled = !variant || !variant.available;
  button.textContent = variant && variant.available ? `Add to bag — ${formatted}` : 'Unavailable';
  if (price && formatted) price.textContent = formatted;
});
